import { ReactElement } from "react";

import { Nullable } from "../../../common/types/types";
import Condition from "../../../components/Conditional/Condition";
import ImageComponent from "../../../components/elements/Image/Image";

interface IProps {
	img: Nullable<string>;
}

const ItemImage = ({ img }: IProps): ReactElement => {
	return (
		<Condition check={!!img}>
			<div className="PDPItemImageContainer">
				<ImageComponent src={img} className="ItemImage" />
			</div>
		</Condition>
	);
};

export default ItemImage;
